import React, { useState, useEffect } from 'react';

const Carousel = () => {
  // Define the images 
  const images = [
    'images/cause1.png',
    'images/cause2.png',
    'images/cause3.png',
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 3000);
    return () => clearInterval(interval); 
  }, [currentIndex]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="relative w-full max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-5xl mx-auto overflow-hidden mt-12 sm:mt-16 md:mt-20 px-4 sm:px-6 md:px-0">
      
      {/* Image Slider Container */}
      <div className="relative w-full h-64 sm:h-80 md:h-96 lg:h-[500px] xl:h-[600px] rounded-2xl overflow-hidden shadow-2xl">
        <img
          src={images[currentIndex]}
          alt={`slide-${currentIndex}`}
          className="w-full h-full object-cover transition-transform duration-700 ease-in-out hover:scale-105"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
      </div>

      {/* Navigation Buttons */}
      {/* Left Arrow */}
      <button
        onClick={goToPrevious}
        className="absolute top-1/2 left-2 sm:left-4 md:left-6 transform -translate-y-1/2 
                   bg-white/90 backdrop-blur-sm text-gray-800 
                   w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 
                   rounded-full shadow-xl 
                   flex items-center justify-center
                   hover:bg-gray-800 hover:text-white 
                   transition-all duration-300 
                   hover:scale-110 
                   focus:outline-none focus:ring-4 focus:ring-gray-300
                   group"
        aria-label="Previous slide"
      >
        <svg 
          className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 transform group-hover:-translate-x-0.5 transition-transform" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={3} 
            d="M15 19l-7-7 7-7" 
          />
        </svg>
      </button>

      {/* Right Arrow */}
      <button
        onClick={goToNext}
        className="absolute top-1/2 right-2 sm:right-4 md:right-6 transform -translate-y-1/2 
                   bg-white/90 backdrop-blur-sm text-gray-800 
                   w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 
                   rounded-full shadow-xl 
                   flex items-center justify-center
                   hover:bg-gray-800 hover:text-white 
                   transition-all duration-300 
                   hover:scale-110 
                   focus:outline-none focus:ring-4 focus:ring-gray-300
                   group"
        aria-label="Next slide"
      >
        <svg 
          className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 transform group-hover:translate-x-0.5 transition-transform" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={3} 
            d="M9 5l7 7-7 7" 
          />
        </svg>
      </button>

      {/* Dots Indicator */}
      <div className="absolute -bottom-8 sm:-bottom-10 md:-bottom-12 left-0 right-0 flex justify-center items-center gap-2 sm:gap-3">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-gray-400 ${
              index === currentIndex 
                ? 'bg-gray-800 w-8 sm:w-10 md:w-12 h-2.5 sm:h-3' 
                : 'bg-gray-400 w-2.5 sm:w-3 h-2.5 sm:h-3 hover:bg-gray-600'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Optional: Slide Counter */}
      <div className="absolute top-4 right-4 sm:top-6 sm:right-6 
                      bg-white/90 backdrop-blur-sm 
                      px-3 py-1.5 sm:px-4 sm:py-2 
                      rounded-full shadow-lg">
        <span className="text-xs sm:text-sm md:text-base font-black text-gray-800">
          {currentIndex + 1} / {images.length}
        </span>
      </div>

    </div>
  );
};

export default Carousel;



// import React, { useState, useEffect } from 'react';

// const Carousel = () => {
//   // Define the images 
//   const images = [
//     'images/cause1.png',
//     'images/cause2.png',
//     'images/cause3.png',

//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Auto-slide every 3 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       goToNext();
//     }, 3000);
//     return () => clearInterval(interval); 
//   }, [currentIndex]);

//   const goToPrevious = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? images.length - 1 : prevIndex - 1
//     );
//   };

//   const goToNext = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === images.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   return (
//     <div className="relative w-full max-w-4xl mx-auto overflow-hidden mt-20">
//       {/* Image Slider */}
//       <div className="w-full h-96">
//         <img
//           src={images[currentIndex]}
//           alt={`slide-${currentIndex}`}
//           className="w-full h-full object-cover"
//         />
//       </div>

//       {/* Left Arrow */}
//       <button
//         onClick={goToPrevious}
//         className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full focus:outline-none"
//       >
//         &#10094;
//       </button>

//       {/* Right Arrow */}
//       <button
//         onClick={goToNext}
//         className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full focus:outline-none"
//       >
//         &#10095;
//       </button>

//       {/* Dots Indicator */}
//       <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
//         {images.map((_, index) => (
//           <span
//             key={index}
//             className={`w-3 h-3 rounded-full ${
//               index === currentIndex ? 'bg-white' : 'bg-gray-400'
//             }`}
//             onClick={() => setCurrentIndex(index)}
//           ></span>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Carousel;
